import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { getToolUseIdForResult, toolUseInputsById } from '../utils/chatHelpers';
export function reduceTools(state, action) {
  switch (action.type) {
    case 'TOOL_USE_DETECTED':
      {
        const activeTools = action.blocks.map(b => ({
          toolUseId: getToolUseIdForResult(b),
          toolName: b.name,
          input: convertFieldValueAvroToJson(b.input),
          status: 'pending'
        }));
        return Object.assign({}, state, {
          activeTools,
          pendingToolResults: new Map(),
          pendingApprovals: new Map(),
          status: 'AWAITING_TOOL'
        });
      }
    case 'TOOL_APPROVAL_REQUIRED':
      {
        const activeTools = action.blocks.map(b => {
          var _action$approvalDescr, _action$approvalPrevi;
          const toolUseId = getToolUseIdForResult(b);
          const approvalDescription = (_action$approvalDescr = action.approvalDescriptions) === null || _action$approvalDescr === void 0 ? void 0 : _action$approvalDescr.get(toolUseId);
          const approvalPreview = (_action$approvalPrevi = action.approvalPreviews) === null || _action$approvalPrevi === void 0 ? void 0 : _action$approvalPrevi.get(toolUseId);
          return Object.assign({
            toolUseId,
            toolName: b.name,
            input: convertFieldValueAvroToJson(b.input),
            status: 'pending'
          }, approvalDescription !== undefined && {
            approvalDescription
          }, approvalPreview !== undefined && {
            approvalPreview
          });
        });
        return Object.assign({}, state, {
          activeTools,
          pendingApprovals: new Map(),
          status: 'AWAITING_APPROVAL'
        });
      }
    case 'TOOL_RESULT_SET':
      {
        const nextResults = new Map(state.pendingToolResults);
        nextResults.set(action.toolUseId, action.result);
        const activeTools = state.activeTools.map(t => t.toolUseId === action.toolUseId ? Object.assign({}, t, {
          status: action.status,
          result: 'content' in action.result ? action.result : {
            content: action.result.message
          }
        }) : t);
        return Object.assign({}, state, {
          pendingToolResults: nextResults,
          activeTools
        });
      }
    case 'TOOL_APPROVAL_SET':
      {
        const nextApprovals = new Map(state.pendingApprovals);
        nextApprovals.set(action.toolUseId, Object.assign({
          toolUseId: action.toolUseId,
          approved: action.approved
        }, action.denialFeedback !== undefined ? {
          denialFeedback: action.denialFeedback
        } : {}, action.alwaysAllow !== undefined ? {
          alwaysAllow: action.alwaysAllow
        } : {}));
        return Object.assign({}, state, {
          pendingApprovals: nextApprovals
        });
      }
    case 'TOOL_STATUS_UPDATED':
      {
        const activeTools = state.activeTools.map(t => t.toolUseId === action.toolUseId ? Object.assign({}, t, action.update) : t);
        return Object.assign({}, state, {
          activeTools
        });
      }
    case 'MESSAGE_APPEND':
      {
        // The input captured at TOOL_USE_DETECTED comes from the streamed partial-JSON
        // deltas, which omit any field the backend injects after the model finishes
        // emitting the call (e.g. the run-confirmation card's remaining-runs quota, added
        // by a preToolUse hook). Those injected fields ride only the authoritative full
        // message, so reconcile each matching active tool's input from it once it lands.
        // Input only — status and result are left alone — so this never re-runs or
        // re-resolves a tool; and reconciling here in the reducer keeps it clear of the
        // coordinator's dispatch/`executing` dedupe, which otherwise pins the
        // pre-injection input for the whole time an external tool's card is up.
        if (state.activeTools.length === 0) {
          return state;
        }
        const reconciledInputs = toolUseInputsById(action.message);
        if (reconciledInputs.size === 0) {
          return state;
        }
        let changed = false;
        const activeTools = state.activeTools.map(t => {
          if (!reconciledInputs.has(t.toolUseId)) {
            return t;
          }
          changed = true;
          return Object.assign({}, t, {
            input: reconciledInputs.get(t.toolUseId)
          });
        });
        return changed ? Object.assign({}, state, {
          activeTools
        }) : state;
      }
    case 'TOOL_CLEAR':
      return Object.assign({}, state, {
        activeTools: [],
        pendingToolResults: new Map(),
        pendingApprovals: new Map()
      });
    case 'RESET':
      return Object.assign({}, state, {
        activeTools: [],
        pendingToolResults: new Map(),
        pendingApprovals: new Map(),
        cancelled: false
      });
    default:
      return state;
  }
}